import Layout from '@/layout'

const asyncPurchaseRoutes = {
  path: '/purchase/sub',
  component: Layout,
  redirect: 'noRedirect',
  name: '采购订单',
  funcPerms: 'purchase:sub',
  meta: {
    title: '采购订单',
    icon: '',
    affix: false,
    noCache: false
  },
  children: [
    {
      path: '/purchase/sub/bagSource/subcontract',
      component: () => import('@/views/purchase/bagSource/subcontract.vue'),
      name: '采购申请分包',
      funcPerms: 'purchase:sub:bagSource:subcontract',
      meta: {
        title: '采购申请分包',
        icon: '',
        affix: false,
        noCache: false
      }
    },
    {
      path: '/purchase/sub/bagSource/packageTogether',
      component: () => import('@/views/purchase/bagSource/packageTogether.vue'),
      name: '采购订单',
      funcPerms: 'purchase:sub:bagSource:packageTogether',
      meta: {
        title: '采购订单',
        icon: '',
        affix: false,
        noCache: false
      }
    }
  ]
}

export default asyncPurchaseRoutes
